import {formsJson} from "../../../mrbgLib/formsJson.js";
import {createSlice} from '@reduxjs/toolkit';

var
  path = decodeURI(window.location.pathname.match(/^\/([^\/]*)/)[1]),
  mrbgVars = {},
  formsJsKey;

if( path==='panel' )
  formsJsKey = 'EP';
else if( path==='login' )
  formsJsKey = 'login';

export const
  __DEFAULT_FORM_SETTINGS = {
  msgTxt: {},       // FORM MESSAGE BOX TEXT
  btnTxt: '',       // FORM BUTTON TEXT
  btnCls: '',       // FORM BUTTON CLASS
  redFld: [],       // FIELDS WITH RED BORDER FOR WARNING
  disabled: [],     // DISABLE FIELDS
  hideInp: {},      // HIDE INPUTS NAME AND VALUE
  timer: '',        // TIMER FOR FIELDS THAT MUST BE FILLED IN A LIMIT TIME
  imgInputName: '', // FILE_INPUT STATUS FOR SHOW CROP_IMAGE
  oldImg: [],       // OLD_IMAGE TO UPDATE CONTENT THAT CONTAINS IMAGES
  STV: {},          // MRBG_SELECT_TAG VALUE
  STN: {},          // MRBG_SELECT_TAG NUMBER FOR MULTI MODE
  op: '',           // OPERATION => FOR CHANGE FOR EXAMPLE FROM INSERT TO UPDATE
  partsLen: {},     // FORMS PART LENGTH
  sundryField: {}   // THE VALUES OF THE FIELDS WHOSE CHANGES AFFECT OTHER COMPONENT.
},
  __CROP_IMG_OBJECT = { imgSrc:[], cw:[], ch:[], iw:[], ih:[], tlx:[], tly:[] };
const initialState = {
  url: 'https://candelahub.com',
  // url: 'http://localhost/candela',
  enTitle: 'candela hub',
  faTitle: 'کندلا هاب',
  __CIO: {},
  formsJsKey: formsJsKey,
  activeForms: formsJsKey==='login'? ['signIn']:['3dayChart__TLFrame','todaySession__TFFrame'],
  activePopups: {
    bottomPU: '',
    fullPU: '',
    leftPU: '',
  },
  billAmount: {},
  device: (() => {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];
    return toMatch.some(item => navigator.userAgent.match(item)) ? 'mob' : 'lop';
  })(),
  dynamicChartKey: {},
  formsSettings: {},
  mrbgVars: { ...mrbgVars },
  myNotifications: {}
};

export const mrbgSlice = createSlice({
  name: 'mrbg',
  initialState,
  reducers: {
    activeFormPanel( state, action ){
      state.activeForms =
        Array.isArray(action.payload)?
          action.payload:
          ['todaySession__TFFrame','3dayChart__TLFrame'].includes(action.payload)?
            ['todaySession__TFFrame','3dayChart__TLFrame']:
            [action.payload];
    },
    add2ActiveFormPanel( state, action ){
      var newList = [...state.activeForms];
      ['todaySession__TFFrame','3dayChart__TLFrame'].includes(action.payload)?
        newList.push('todaySession__TFFrame','3dayChart__TLFrame'):
        newList.push(action.payload)
      state.activeForms = [...newList];
    },
    addRowTblInput( state, action ){
      var
        { formID, tblID, colName, colVal, colOpt } = action.payload,
        fjsOrigin = state.mrbgVars.readySettings[formID],
        newRows                                    = { ...Object.keys(formsJson[state.formsJsKey][fjsOrigin].forms[formID].tableInputs[tblID]).createObjWithThisKeys('') },
        tblInfo                                    = [...state.mrbgVars[tblID] || []];

      for( let i = 0; i<colVal?.length; i++ )
        tblInfo[i] = { ...newRows, [colName]: colOpt[colVal[i]] };

      tblInfo.splice(colVal?.length || 0);

      state.mrbgVars = { ...state.mrbgVars, ...{ [tblID]: [...tblInfo] } };
    },
    changePartNum( state, action ){
      var
        { formID, pName, pLen }                            = action.payload;
      state.formsSettings[formID].partsLen[pName].currentR = pLen;
    },
    hasChart( state ){
      state.HAS_CHART = true;
    },
    newFormsSetting( state, action ){
      state.formsSettings = action.payload;
    },
    redFldToWhite( state, action ){
      var
        { formID, name } = action.payload,
        fs               = state.formsSettings[formID],
        i                = fs.redFld.indexOf(name);

      if( i> -1 ){
        fs.redFld.splice(i, 1);
        if( fs.redFld.length == 0 )
          fs.msgTxt = {}
      }
      state.formsSettings = {
        ...state.formsSettings,
        [formID]: fs
      };
    },
    resetForm( state, action ){

      let fs = state.formsSettings[action.payload];
      Object.keys(fs.STV).forEach(k => fs.STV[k] = [])
      Object.keys(fs.STN).forEach(k => fs.STN[k] = [])
      Object.keys(fs.partsLen).forEach(k => fs.partsLen[k].currentR = fs.partsLen[k].defaultR)

      state.formsSettings =
        Object.assign(
          { ...state.formsSettings },
          {
            [action.payload]: {
              ...__DEFAULT_FORM_SETTINGS,
              STV: { ...fs.STV },
              STN: { ...fs.STN },
              partsLen: { ...fs.partsLen }
            }
          }
        );
    },
    removeGM( state, action ){
      let
        formID = action.payload,
        fs = state.formsSettings[formID];
      fs.msgTxt = {};
      state.formsSettings = {
        ...state.formsSettings,
        [formID]: fs
      }
    },
    setActivePopups( state, action ){
      state.activePopups = { ...state.activePopups, ...action.payload };
    },
    setChartKey( state, action ){
      var
        { id, chartKey, pointKey } = action.payload,
        newObj                     =
          pointKey === undefined?
            { [id]: { cName: chartKey, pName: state.dynamicChartKey[id]?.pName } }:
            { [id]: { cName: chartKey, pName: pointKey } };
      state.dynamicChartKey = {
        ...state.dynamicChartKey,
        ...newObj
      }
    },
    changeFormsJsKey( state, action ){
      state.formsJsKey = action.payload;
    },
    setSettingsForm( state, action ){
      state.formsSettings = Object.assign({ ...state.formsSettings }, { ...action.payload })
    },
    setImgCrop( state, action ){
      state.__CIO = action.payload;
    },
    selectTagNum( state, action ){
      var { formID, STName, num } = action.payload;

      let fs         = state.formsSettings[formID];
      fs.STN[STName] = num;

      state.formsSettings = {
        ...state.formsSettings,
        [formID]: fs
      };
    },
    selectTagValue( state, action ){
      var
        { formID, STName, value } = action.payload,
        fs = state.formsSettings[formID];

      if( JSON.stringify(fs.STV[STName]) !== JSON.stringify(value) ){
        fs.STV[STName] = value;

        state.formsSettings = {
          ...state.formsSettings,
          [formID]: fs
        };
      }
    },
    setToken( state, action ){
      state.__TK = action.payload;
    },
    updateVars( state, action ){
      state.mrbgVars = { ...state.mrbgVars, ...action.payload };
    },
    updateNotification( state, action ){
      state.myNotifications = action.payload;
    },
    updBillAmount( state, action ){
      var newBillAmount =
            Object.assign(
              { totalAmount: 0, finalAmount: 0, discount: 0, paidAmount: 0 },
              { ...state.billAmount[action.payload.formID] || {} },
              action.payload.info
            );

      newBillAmount.percent =
        newBillAmount.paidAmount && newBillAmount.finalAmount?
        parseFloat(( newBillAmount.paidAmount/newBillAmount.finalAmount*100 ).toFixed(2)): 0,
        newBillAmount.remainder = newBillAmount.finalAmount-newBillAmount.paidAmount;

      state.mrbgVars.billAmount = Object.assign(state.billAmount || {}, { [action.payload.formID]: { ...newBillAmount } });
    },
    setHideInp( state, action ){
      var
        {formID, fieldName, fieldValue} = {...action.payload},
        fs = state.formsSettings[formID];

      fs.hideInp[fieldName] = fieldValue ;

      state.formsSettings = {
        ...state.formsSettings,
        [formID]: fs
      };
    },
    setSundryField( state, action ){
      var
        {formID, fieldName, fieldValue} = {...action.payload},
        fs = JSON.parse(JSON.stringify(state.formsSettings[formID])),
        match = fieldName.match(/^([^\[]*)\[(\d+)\]$/),
        index;

      if( !match ){
        if( fieldValue===undefined ){
          if( Object.hasOwn(fs.sundryField,fieldName) )
            delete fs.sundryField[fieldName];
        }
        else
          fs.sundryField[fieldName] = fieldValue;
      }
      else{
        fieldName  = match[1];
        index      = match[2];
        if( fieldValue===undefined ){
          if( Object.hasOwn(fs.sundryField,fieldName) && Object.hasOwn(fs.sundryField[fieldName],index) ){
            delete fs.sundryField[fieldName][index];
            if( Object.values(fs.sundryField[fieldName]).length===0 )
              delete fs.sundryField[fieldName];
          }
        }
        else{
          fs.sundryField[fieldName] =
            Object.hasOwn(fs.sundryField, fieldName)?
              {...fs.sundryField[fieldName], [index]:fieldValue}:
              {[index]:fieldValue}
        }
      }

      if( formID==='areSrt' && fieldName==='gender' ){
        state.mrbgVars.are__SL =
          fieldValue?
            [...state.mrbgVars.areRef__SL[fieldValue]]:
            []
      }

      state.formsSettings = {
        ...state.formsSettings,
        [formID]: fs
      };
    }
  }
});

export const {
  activeFormPanel,
  add2ActiveFormPanel,
  addRowTblInput,
  changePartNum,
  setSettingsForm,
  hasChart,
  newFormsSetting,
  redFldToWhite,
  resetForm,
  removeGM,
  setActivePopups,
  setChartKey,
  changeFormsJsKey,
  setImgCrop,
  selectTagNum,
  selectTagValue,
  setToken,
  updateVars,
  updateNotification,
  setHideInp,
  setSundryField,
  updBillAmount
} = mrbgSlice.actions;

export default mrbgSlice.reducer;